import { NgModule } from '@angular/core';

import { ClickOutsideDirective } from './click.outside.directive';

/**
 * The ClickOutsideSharedDirectiveModule module
 *
 * import { ClickOutsideSharedDirectiveModule } from 'styleguide/src/shared/directive/click.outside/click.outside.module';
 */
@NgModule({
    declarations: [
        ClickOutsideDirective
    ],
    imports: [],
    exports: [
        ClickOutsideDirective
    ]
})
// tslint:disable-next-line:no-unnecessary-class
export class ClickOutsideSharedDirectiveModule {}
